export const categoryConstants = {
  BASE_PATH: '/v1/categories',
};
